var React = require('react');

function CheckMark (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_3601","data-name":"Path 3601","d":"M705,287.257a12,12,0,1,1,12-12A12.013,12.013,0,0,1,705,287.257Zm0-21a9,9,0,1,0,9,9A9.01,9.01,0,0,0,705,266.257Zm6.625,6.35-2.121-2.121-6.359,6.359L700.5,274.2l-2.121,2.121,4.77,4.771Z","transform":"translate(-693 -263.257)","fill":"#464af0"}));
}

CheckMark.defaultProps = {"id":"Odpowiedź_-_ikona","data-name":"Odpowiedź - ikona","width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = CheckMark;

CheckMark.default = CheckMark;
